import React from "react";
import clsx from "clsx";

const AppOutlineButton = ({
  children,
  variant = "primary",
  size = "md",
  disabled = false,
  onClick,
  className = "",
  ...restProps
}) => {
  const baseStyles =
    "inline-flex items-center justify-center whitespace-nowrap font-medium rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2";

  const variants = {
    primary:
      "border border-primary text-primary hover:bg-blue-50 focus:ring-primary",
    secondary:
      "border border-gray-300 text-gray-700 hover:bg-gray-100 focus:ring-gray-400",
    danger:
      "border border-red-600 text-red-600 hover:bg-red-50 focus:ring-red-500",
  };

  const sizes = {
    sm: "px-3 py-2 text-sm",
    md: "px-4 py-3 text-sm",
    lg: "px-6 py-3 text-base",
  };

  const disabledStyles = disabled
    ? "opacity-50 cursor-not-allowed pointer-events-none"
    : "";

  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={clsx(
        baseStyles,
        variants[variant],
        sizes[size],
        disabledStyles,
        className
      )}
      {...restProps}
    >
      {children}
    </button>
  );
};

export default AppOutlineButton;
